export default () => {
	const form = document.querySelector('[data-form="enquiry"]');
	if (form !== null) {
		form.addEventListener("enquiry-type-change", (e) => {
			const type = e.detail;

			for (const item of form.querySelectorAll("[data-fieldset]")) {
				const fs = item.getAttribute("data-fieldset");

				// Loop through required fields and remove 'required' attr
				for (const f of item.querySelectorAll("[data-required]")) {
					f.removeAttribute("required");
				}

				item.style.display = "none";
				item.setAttribute("aria-hidden", "true");

				// If matching fieldset to chosen enquiry type
				if (type !== "" && (fs === type || fs === "any")) {
					item.style.display = "block";
					item.setAttribute("aria-hidden", "false");

					// Loop through data-required fields and add 'required' attr
					for (const f of item.querySelectorAll("[data-required]")) {
						f.setAttribute("required", "");
					}
				}
			}
		});

		const selector = form.querySelector("[data-enquiry-type-selector]");
		if (selector !== null) {
			selector.addEventListener("change", () => {
				const ev = new CustomEvent("enquiry-type-change", {
					bubbles: true,
					detail: selector.value,
				});
				selector.dispatchEvent(ev);
			});
		}
	}
};
